import { makeStyles } from "@material-ui/core";
const sizeToPx = {
    small: 24,
    sMedium: 32,
    medium: 36,
    large: 40,
};
const FTLIconButtonStyle = makeStyles((theme) => ({
    root: ({ size = "medium", disableBackground, color = "inherit", }) => ({
        width: sizeToPx[size],
        height: sizeToPx[size],
        backgroundColor: disableBackground ? "transparent !important" : "initial",
        color: color !== "inherit" ? theme.palette.icon[color] : "inherit",
        borderRadius: "50%",
        "& svg": {
            color: "inherit",
        },
    }),
}));
export default FTLIconButtonStyle;
//# sourceMappingURL=FTLIconButtonStyle.js.map